import React, {
  useEffect,
  useState,
} from "react";

import {
  fetchCompetitiveMatrix,
  formatApiError,
} from "../services/api";

function CompetitiveMatrix({
  onPlatformClick,
}) {

  // =====================================================
  // STATES
  // =====================================================

  const [matrixData, setMatrixData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  // =====================================================
  // LOAD MATRIX DATA
  // =====================================================

  useEffect(() => {

    loadMatrixData();

  }, []);

  const loadMatrixData =
    async () => {

      try {

        setLoading(true);

        const response =
          await fetchCompetitiveMatrix();

        setMatrixData(
          response.data || []
        );

      } catch (err) {

        console.error(
          "COMPETITIVE MATRIX ERROR:",
          err
        );

        setError(
          formatApiError(err)
        );

      } finally {

        setLoading(false);
      }
    };

  // =====================================================
  // CARD CLASS
  // =====================================================

  const getCardClass = (
    color
  ) => {

    return `matrix-card ${color}`;
  };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="matrix-loading">

        Loading Competitive Matrix...

      </div>
    );
  }

  // =====================================================
  // ERROR
  // =====================================================

  if (error) {

    return (

      <div className="matrix-error">

        {error}

      </div>
    );
  }

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="matrix-container">

      {/* =========================================
          HEADER
      ========================================= */}

      <div className="section-header">

        <div>

          <h2>
            Competitive Position Matrix
          </h2>

          <p>
            Platform-wise pricing
            intelligence and
            competitive market analysis
          </p>

        </div>

      </div>

      {/* =========================================
          GRID
      ========================================= */}

      <div className="matrix-grid">

        {matrixData.map(
          (item, index) => (

            <div
              key={index}
              className={getCardClass(
                item.color
              )}
              onClick={() =>
                onPlatformClick(
                  item.platform,
                  item.products
                )
              }
            >

              {/* =================================
                  TOP
              ================================= */}

              <div className="matrix-top">

                <div>

                  <h3>
                    {item.platform}
                  </h3>

                  <div className="matrix-subtitle">

                    Pricing Intelligence

                  </div>

                </div>

                <div className="matrix-badge">

                  {item.status}

                </div>

              </div>

              {/* =================================
                  STATS
              ================================= */}

              <div className="matrix-stats">

                {/* CHEAPEST */}

                <div className="matrix-stat">

                  <span>
                    Cheapest
                  </span>

                  <strong>
                    {
                      item.cheapestCount
                    }
                  </strong>

                </div>

                {/* EXPENSIVE */}

                <div className="matrix-stat">

                  <span>
                    Expensive
                  </span>

                  <strong>
                    {
                      item.expensiveCount
                    }
                  </strong>

                </div>

              </div>

              {/* =================================
                  KPI SECTION
              ================================= */}

              <div className="matrix-kpi-grid">

                {/* MARKET SHARE */}

                <div className="matrix-kpi-card">

                  <label>
                    Market Share
                  </label>

                  <strong>
                    {item.score}%
                  </strong>

                </div>

                {/* AVG GAP */}

                <div className="matrix-kpi-card">

                  <label>
                    Avg Gap
                  </label>

                  <strong>
                    {item.avgGap}%
                  </strong>

                </div>

              </div>

              {/* =================================
                  RISK
              ================================= */}

              <div className="risk-row">

                <span>
                  Business Risk
                </span>

                <div
                  className={`risk-badge ${item.risk.toLowerCase()}`}
                >

                  {item.risk}

                </div>

              </div>

              {/* =================================
                  PROGRESS
              ================================= */}

              <div className="matrix-progress">

                <div
                  className="matrix-progress-fill"
                  style={{
                    width:
                      `${item.score}%`,
                  }}
                />

              </div>

              {/* =================================
                  FOOTER
              ================================= */}

              <div className="matrix-footer">

                Click to view
                pricing insights →

              </div>

            </div>

          )
        )}

      </div>

    </div>
  );
}

export default CompetitiveMatrix;